import {ILayerInfos} from '../interfaces/reducers'
import {IFeatureLayerInfo} from '../interfaces/models'
import {IPaylodAction} from '../interfaces/dispatchers'
import LayerInfosActions from '../enums/ActionTypes/LayerInfosActions'

const initState = {
  featureLayerInfos: {},
  deniedServices: {},
  failedServices: {},
  visibleLayers: {},
  hiddenGroupsCaches: {},
  vectorLayerImagesLoaded: false,
  loadingLayers: {}
}
let stateSnapShot: Readonly<ILayerInfos>

const layerInfos = (state = initState, action: IPaylodAction) => {
  switch (action.type) {
    case LayerInfosActions.CLEAR_FAILED_RECORDS:
      stateSnapShot = {
        ...state,
        deniedServices: {},
        failedServices: {}
      }
      break
    case LayerInfosActions.ADD_LAYER_INFOS:
      stateSnapShot = {
        ...state,
        featureLayerInfos: {...state.featureLayerInfos, ...action.payload.featureLayerInfos},
        deniedServices: {...state.deniedServices, ...action.payload.deniedServices},
        failedServices: {...state.failedServices, ...action.payload.failedServices}
      }
      break
    case LayerInfosActions.VECTOR_LEGEND_IMAGES_LOADED:
      stateSnapShot = {
        ...state,
        vectorLayerImagesLoaded: action.payload
      }
      break
    case LayerInfosActions.CLEAR_ALL_DATA:
      stateSnapShot = {
        ...state,
        featureLayerInfos: {},
        deniedServices: {},
        failedServices: {}
      }
      break
    case LayerInfosActions.ADD_VISIBLE_LAYERS:
      stateSnapShot = {
        ...state,
        visibleLayers: {...state.visibleLayers, ...action.payload}
      }
      break
    case LayerInfosActions.SET_VISIBLE_LAYERS:
      stateSnapShot = {
        ...state,
        visibleLayers: {...action.payload}
      }
      break
    case LayerInfosActions.SET_HIDDEN_GROUP_CACHE:
      stateSnapShot = {
        ...state,
        hiddenGroupsCaches: {...action.payload}
      }
      // Only save after initialization (componentDidMount already ran = previous state was non-empty)
      if (Object.keys(state.hiddenGroupsCaches).length > 0) {
        try {
          const key = `gis_hidden_groups_${(window as any).appType || 'default'}`
          localStorage.setItem(key, JSON.stringify(action.payload))
        } catch (_) {}
      }
      break
    case LayerInfosActions.SET_LOADING_LAYERS:
      stateSnapShot = {
        ...state,
        loadingLayers: {...action.payload}
      }
      break
    default:
      stateSnapShot = {...state}
      break
  }
  return stateSnapShot
}
;(window as any).glis = () => {
  return stateSnapShot
}
export const getLayerInfo = (id: string): IFeatureLayerInfo | undefined => {
  return stateSnapShot.featureLayerInfos[id]
}
export default layerInfos
